var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 30,
    viewBox: "0 0 170 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.5875L22.725 26.25L20.675 17.4625L27.5 11.55L18.5125 10.775L15 2.5L11.4875 10.775L2.5 11.55L9.3125 17.4625L7.275 26.25L15 21.5875Z",
    fill: "#FDC536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 21.5875L57.725 26.25L55.675 17.4625L62.5 11.55L53.5125 10.775L50 2.5L46.4875 10.775L37.5 11.55L44.3125 17.4625L42.275 26.25L50 21.5875Z",
    fill: "#FDC536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85 21.5875L92.725 26.25L90.675 17.4625L97.5 11.55L88.5125 10.775L85 2.5L81.4875 10.775L72.5 11.55L79.3125 17.4625L77.275 26.25L85 21.5875Z",
    fill: "#FDC536"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 21.5875L127.725 26.25L125.675 17.4625L132.5 11.55L123.513 10.775L120 2.5L116.488 10.775L107.5 11.55L114.312 17.4625L112.275 26.25L120 21.5875Z",
    fill: "#FDC536"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5 11.55L158.513 10.775L155 2.5L151.487 10.7875L142.5 11.55L149.325 17.4625L147.275 26.25L155 21.5875L162.725 26.25L160.688 17.4625L167.5 11.55ZM155 19.25V7.625L157.137 12.675L162.612 13.15L158.463 16.75L159.713 22.1L155 19.25Z",
    fill: "#FDC536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.c27170aace0e35989a9945cf3d79dace.svg";
export { ForwardRef as ReactComponent };